// Implements: .fs-eyebrow from ui_kits/rehaut-flagships/flagship.css —
// the uppercase mono section label, 10.5px floor.
import type { CSSProperties, ReactNode } from 'react';

export function Eyebrow({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div className="fs-eyebrow" style={style}>{children}</div>;
}
